type ErrorSeverity = "low" | "medium" | "high" | "critical";

export const customClientErrorHandler = (
  error: any = null,
  severity: ErrorSeverity | null = "low",
  title: string = "From customErrorHandler",
  meta: Record<string, any> | null = null
) => {
  let config;
  let appDebug;

  if (import.meta.client) {
    config = useNuxtApp().$config;
    appDebug = useNuxtApp().$config.public.appDebug;
  }

  let errorOptions = {
    error,
    severity,
    title,
    meta,
    environment: config?.public.appEnvironment,
  };

  if (import.meta.client) {
    if (appDebug) {
      consoleLog(title, errorOptions, severity);
    }

    if (!config?.public?.ddClientToken) {
      return false;
    }

    const datadogLogs = useNuxtApp().$ddLogs;

    if (datadogLogs) {
      datadogLogs.logger.error(title, errorOptions, error);
    }

    const datadogRum = useNuxtApp().$ddRum;

    if (datadogRum) {
      datadogRum.addError(error, errorOptions);
    }
  }
};
export const customClientWarningHandler = (
  severity: ErrorSeverity | null = "low",
  title: string = "From customErrorHandler",
  meta: any = null
) => {
  let config;
  let appDebug;

  if (import.meta.client) {
    config = useNuxtApp().$config;
    appDebug = useNuxtApp().$config.public.appDebug;
  }

  let warningOptions = {
    severity,
    title,
    meta,
    environment: config?.public.appEnvironment,
  };

  if (import.meta.client) {
    if (appDebug) {
      consoleLog(title, warningOptions, severity);
    }

    if (!config?.public?.ddClientToken) {
      return false;
    }

    const datadogLogs = useNuxtApp().$ddLogs;

    if (datadogLogs) {
      datadogLogs.logger.warn(title, warningOptions);
    }
  }
};

export const customClientErrorHandlerAsync = async (
  error: any = null,
  severity?: ErrorSeverity | null | undefined,
  title: string = "From customErrorHandler",
  meta: any = null
) => {
  customClientErrorHandler(error, severity, title, meta);
};
export const customServerErrorHandler = (
  error: any = null,
  severity: ErrorSeverity | null = "low",
  title: string | null = "From customServerErrorHandler",
  meta: any = null
) => {
  let errorOptions = {
    error: error,
    severity: severity,
    title: title,
    meta: meta,
  };

  consoleLog(title, errorOptions, severity);
};

export const consoleLog = (title, errorOptions, severity) => {
  if (severity === "critical" || severity === "high") {
    console.error(title, errorOptions);
  } else {
    console.log(title, errorOptions);
  }
};

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.provide("customClientErrorHandler", customClientErrorHandler);
  nuxtApp.provide("customClientWarningHandler", customClientWarningHandler);
  nuxtApp.provide(
    "customClientErrorHandlerAsync",
    customClientErrorHandlerAsync
  );
  nuxtApp.provide("customServerErrorHandler", customServerErrorHandler);

  if (!import.meta.client) return;

  // To log previous route inc case of error - 400 or 500
  const router = useRouter();
  router.beforeEach((to, from) => {
    sessionStorage.setItem("previousRoute", from.fullPath);
  });
});
